import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, EmptyState } from '../ui';
import { SearchIcon } from '../ui/icons';

function NotFound() {
  const { t } = useTranslation();
  return (
    <EmptyState icon={SearchIcon} title={t('notFound.title')} titleAs="h1" className="not-found"
                action={<Button as={Link} to="/">{t('notFound.home')}</Button>}>
      {t('notFound.text')}
    </EmptyState>
  );
}

export default NotFound;
